class CurrencyFormatter {
  format(value, currency = true) {
    const intlFormatter = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    });
    let formatted = intlFormatter.format(value);
    formatted = formatted.replace(' ', ' ');
    if (!currency) {
      formatted = formatted.replace('CHF ', '');
    }
    return formatted;
  }
  formatAlternate(value, symbol) {
    const intlFormatter = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    });
    let formatted = intlFormatter.format(value);
    formatted = formatted.replace(' ', ' ');
    formatted = formatted.replace('CHF', '');
    formatted = `${formatted}${symbol ? ' ' + symbol : ''}`;
    return formatted;
  }
}
const currencyFormatter = new CurrencyFormatter();
export default currencyFormatter;